export const ICON_LABEL = 'Select currency';
export const TEXT_AS_P = 'p';
export const TAB_INDEX_0 = 0;
export const OPTION_ROLE = 'option';
export const LISTBOX_ROLE = 'listbox';
export const CURRENCIES_REQUEST_ERROR =
  'An error occured while fetching currencies';
